import {FieldError} from 'react-hook-form';

type Props = {
  error: FieldError | undefined;
};

export default function InputError({error}: Props) {
  return error ? (
    <i className="text-error-primary font-averta-italic text-[13px] mt-2">
      {error.message?.toString()}
    </i>
  ) : null;
}
